import React, { useState, useEffect } from 'react'

import RepeatModal from '../RepeatModal'
import { REPEAT_BOOKING } from '../../helpers'

const RepeatBooking = (props) => {
  const { 
    language,
    recurrence,
    date,
    startTime,
    setRecurrence,
    onShowRepeatBooking,
    getHolidays,
    holidays,
    isVisible,
    previousRecurrence,
    setPreviousRecurrence,
    recurrenceText,
    setRecurrenceText,
    colorTheme,
    disabled
  } = props

  const [isRepeat, setIsRepeat] = useState(Boolean(recurrence))

  useEffect(() => {
      setRecurrenceText(recurrence, language)
  }, [])

  const onSubmit = (recurrence, language) => {
    setRecurrence(recurrence)
    setRecurrenceText(recurrence, language)
    onShowRepeatBooking(false)
  }

  return (
    <React.Fragment>
      <RepeatModal
        colorTheme={colorTheme}
        isVisible={isVisible}
        date={date}
        startTime={startTime}
        recurrence={recurrence}
        setRecurrence={setRecurrence}
        language={language}
        getHolidays={getHolidays}
        holidays={holidays}
        onClose={() => onShowRepeatBooking(false)}
        onSubmit={onSubmit}
        isRepeat={isRepeat}
        setIsRepeat={setIsRepeat}
        previousRecurrence={previousRecurrence}
        setPreviousRecurrence={setPreviousRecurrence}
      />

      <section className='content'>
        <label className='content-header'>{REPEAT_BOOKING.REPEAT[language]}:</label>
        <div className='content-body'>
          <div style={{
            width: '100%',
            border: '1.5px solid #E5E5E5',
            borderRadius: '8px',
            padding: '0 16px',
            minHeight: '48px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            flexWrap: 'nowrap'
          }}>
            <p className='repeat-text' style={{ margin: 0, fontSize: '18px', fontWeight: 400, fontFamily: 'NunitoSans, sans-serif', color: '#0A0A0A' }}>
              {recurrenceText}
            </p>
            {!disabled && (
              <button 
                className='change-button'
                onClick={() => onShowRepeatBooking(true)}
                style={{
                  color: colorTheme || '#D8A253',
                  backgroundColor: 'transparent',
                  border: 'none',
                  cursor: 'pointer',
                  fontSize: '16px',
                  fontWeight: 400,
                  fontFamily: 'NunitoSans, sans-serif',
                  textDecoration: 'underline',
                  padding: 0,
                  whiteSpace: 'nowrap'
                }}
              >
                {REPEAT_BOOKING.CHANGE[language]}
              </button>
            )}
          </div>
        </div>
      </section>
    </React.Fragment>
  )
}

export default RepeatBooking
